module.exports = __webpack_public_path__ + "img/wifi.4cd0b27b.png";